import {
  AREA_OF_CONCERN,
  CALCULUS,
  CARIES,
  PERIAPICAL_RADIOLUCENCY,
  RADIOGRAPHIC_BONELOSS,
  RESTORATIVE_ADJACENT_LUCENCY,
} from '../../../constants';

export const computeFindingGroupCategories = (findingGroupsToRender: any) => {
  if (!findingGroupsToRender) {
    return { Restorative: [], Periodontal: [], Endodontic: [] };
  }
  const categories = findingGroupsToRender?.reduce(
    (categories: any, findingGroup: any) => {
      if (
        findingGroup?.type === CARIES ||
        findingGroup?.type === AREA_OF_CONCERN ||
        findingGroup?.type === RESTORATIVE_ADJACENT_LUCENCY
      ) {
        categories.Restorative.push(findingGroup);
      }
      if (
        findingGroup?.type === RADIOGRAPHIC_BONELOSS ||
        findingGroup?.type === CALCULUS
      ) {
        categories.Periodontal.push(findingGroup);
      }
      if (findingGroup?.type === PERIAPICAL_RADIOLUCENCY) {
        categories.Endodontic.push(findingGroup);
      }
      return categories;
    },
    { Restorative: [], Periodontal: [], Endodontic: [] },
  );
  return categories;
};

export const getFindingsToFilterBySize = (findingGroupsToRender: any) => {
  const cariesSubTypedFindings = findingGroupsToRender?.filter(
    (findingGroup: any) =>
      findingGroup.type === AREA_OF_CONCERN ||
      findingGroup.type === CARIES ||
      findingGroup.type === RESTORATIVE_ADJACENT_LUCENCY,
  );
  const findings: any = [];
  cariesSubTypedFindings?.forEach((findingGroup: any) =>
    findings.push(...findingGroup.findings),
  );
  return findings;
};
